import { Button, Typography } from '@mui/material';
import React from 'react';

interface JobQueuePaginationProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  onFirstPage: () => void;
  onPreviousPage: () => void;
  onNextPage: () => void;
  onLastPage: () => void;
}

const JobQueuePagination: React.FC<JobQueuePaginationProps> = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
  onFirstPage,
  onPreviousPage,
  onNextPage,
  onLastPage,
}) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <div className="job-queue-pagination">
      <div className="pagination-info">
        <Typography
          sx={{
            color: '#6b7280',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
          }}>
          {startItem} to {endItem} of {totalItems.toLocaleString()}
        </Typography>
      </div>

      <div className="pagination-controls">
        <Button
          onClick={onFirstPage}
          disabled={currentPage === 1}
          sx={{
            '&:disabled': {
              color: '#d1d5db',
            },
            '&:hover': {
              backgroundColor: currentPage === 1 ? 'transparent' : '#f3f4f6',
            },
            backgroundColor: 'transparent',
            color: currentPage === 1 ? '#d1d5db' : '#374151',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
            fontWeight: 'medium',
            marginRight: '4px',
            minWidth: 'auto',
            padding: '8px 12px',
            textTransform: 'none',
          }}>
          K
        </Button>

        <Button
          onClick={onPreviousPage}
          disabled={currentPage === 1}
          sx={{
            '&:disabled': {
              color: '#d1d5db',
            },
            '&:hover': {
              backgroundColor: currentPage === 1 ? 'transparent' : '#f3f4f6',
            },
            backgroundColor: 'transparent',
            color: currentPage === 1 ? '#d1d5db' : '#374151',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
            fontWeight: 'medium',
            marginRight: '4px',
            minWidth: 'auto',
            padding: '8px 12px',
            textTransform: 'none',
          }}>
          &lt;
        </Button>

        <Typography
          sx={{
            color: '#374151',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
            marginRight: '4px',
            padding: '8px 12px',
          }}>
          Page {currentPage} of {totalPages}
        </Typography>

        <Button
          onClick={onNextPage}
          disabled={currentPage === totalPages}
          sx={{
            '&:disabled': {
              color: '#d1d5db',
            },
            '&:hover': {
              backgroundColor:
                currentPage === totalPages ? 'transparent' : '#f3f4f6',
            },
            backgroundColor: 'transparent',
            color: currentPage === totalPages ? '#d1d5db' : '#374151',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
            fontWeight: 'medium',
            marginRight: '4px',
            minWidth: 'auto',
            padding: '8px 12px',
            textTransform: 'none',
          }}>
          &gt;
        </Button>

        <Button
          onClick={onLastPage}
          disabled={currentPage === totalPages}
          sx={{
            '&:disabled': {
              color: '#d1d5db',
            },
            '&:hover': {
              backgroundColor:
                currentPage === totalPages ? 'transparent' : '#f3f4f6',
            },
            backgroundColor: 'transparent',
            color: currentPage === totalPages ? '#d1d5db' : '#374151',
            fontFamily: 'Red Hat Display Medium',
            fontSize: '14px',
            fontWeight: 'medium',
            minWidth: 'auto',
            padding: '8px 12px',
            textTransform: 'none',
          }}>
          &gt;|
        </Button>
      </div>
    </div>
  );
};

export default JobQueuePagination;
